module.exports = __webpack_public_path__ + "static/media/RosQualityCertificate.2f6a3e5e.png";